/** Fit a PDF page inside its panel without stretching a desktop preview. */
export const getPdfPageWidth = (containerWidth: number): number => {
  if (!Number.isFinite(containerWidth) || containerWidth <= 32) return 0;
  return Math.min(720, Math.floor(containerWidth) - 32);
};
